export default __webpack_public_path__ + "static/meshmap-docker-extension-for-meshery-0405fe6115a5ad938da13264804615dc.webp";